import { createSlice } from "@reduxjs/toolkit";
import { getCurrencies } from "./CurrencySelectField.thunk";

const initialState = {
  currencies: [], // Format {value, label} for SelectField
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

export const currencySelectFieldSlice = createSlice({
  name: "currencySelectField",
  initialState,
  reducers: {
    resetCurrencies: (state) => {
      state.currencies = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrencies.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getCurrencies.fulfilled, (state, action) => {
        state.currencies = action.payload.currencies;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(getCurrencies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error getting currencies";
      });
  },
});

export const { resetCurrencies } = currencySelectFieldSlice.actions;
export default currencySelectFieldSlice.reducer;

